import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { MessageCircle } from 'lucide-react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const FAQ = ({ config = {} }) => {
  const [ref, isVisible] = useScrollAnimation();
  
  const defaultFaqs = [
    {
      question: '¿Cómo funciona la colaboración con JG Models?',
      answer: 'Después de contactarnos, evaluamos tu perfil y potencial. Si encajas con nuestra visión, comenzamos con una incorporación personalizada donde te guiamos en cada paso del proceso.'
    },
    {
      question: '¿Cuánto cuesta trabajar con JG Models?',
      answer: 'No pagas costos fijos iniciales. Trabajamos con un modelo basado en resultados — transparente, justo y alineado con tu éxito.'
    },
    {
      question: '¿Qué tan seguro está mi contenido con ustedes?',
      answer: 'Tu seguridad es nuestra máxima prioridad. Implementamos sistemas de protección, prevenimos filtraciones, trabajamos directamente con las plataformas y nos aseguramos de que tu contenido esté completamente protegido.'
    },
    {
      question: '¿Quién me apoyará en el proceso?',
      answer: 'Tendrás un equipo dedicado de profesionales que conocen la industria a fondo y están disponibles 24/7 para responder todas tus dudas y apoyarte en cada etapa.'
    },
    {
      question: '¿Qué necesito para empezar con JG Models?',
      answer: 'Solo necesitas compromiso, disciplina y tu celular. Nosotros nos ocupamos del resto: configuración técnica, estrategia de contenido, gestión de chats y todo lo necesario para tu éxito.'
    },
    {
      question: '¿Qué hace diferente a JG Models de otras agencias?',
      answer: 'Trabajamos con 100% profesionales capacitados, ofrecemos soporte 24/7 personalizado, sin costos iniciales, y colaboramos con las más altas exponentes de la industria para garantizar tu crecimiento.'
    }
  ];
  
  const faqs = config.faqs || defaultFaqs;

  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    window.open('https://api.whatsapp.com/send?phone=573011920219&text=Hola,%20tengo%20una%20pregunta%20sobre%20JG%20Models', '_blank');
  };

  return (
    <section ref={ref} className="py-24 bg-[#1d1e20] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-[#c8784e] rounded-full filter blur-3xl" />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className={`text-center mb-16 fade-in ${isVisible ? 'visible' : ''}`}>
          <p className="text-[#c8784e] uppercase tracking-wider mb-4 font-semibold">PREGUNTAS FRECUENTES</p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            ¿Tienes dudas?
          </h2>
          <p className="text-gray-400 text-lg font-light">
            Encuentra respuestas rápidas a las preguntas más comunes sobre JG Models.
          </p>
        </div>

        <div className={`max-w-3xl mx-auto fade-in delay-200 ${isVisible ? 'visible' : ''}`}>
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-black/40 backdrop-blur-sm border border-gray-800 rounded-xl px-6 hover:border-[#c8784e]/50 transition-all duration-300"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-white hover:text-[#c8784e] py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-300 pb-6 leading-relaxed font-light">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 text-center">
            <p className="text-gray-400 mb-6 font-light">
              ¿No encuentras lo que buscas?
            </p>
            <button
              onClick={handleWhatsAppClick}
              className="inline-flex items-center gap-3 bg-[#c8784e] text-black px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#d89a6f] transition-all duration-300 hover:scale-105 cursor-pointer"
            >
              <MessageCircle size={24} />
              Contáctanos por WhatsApp
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;